<!-- Toast Container - Fixed position in top-right corner -->
<div class="toast-container position-fixed top-0 end-0 p-3">
  @for (toast of toasts; track trackByToast($index, toast)) {
    <div
      class="toast show"
      [class]="getToastClass(toast.type)"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <!-- Toast Header -->
      <div class="toast-header" [class]="getToastClass(toast.type)">
        <i class="bi me-2" [class]="toast.icon"></i>
        <strong class="me-auto">{{ toast.title }}</strong>
        <small class="opacity-75">just now</small>
        @if (toast.dismissible) {
          <button
            type="button"
            class="btn-close btn-close-white ms-2"
            aria-label="Close"
            (click)="dismiss(toast)"
          ></button>
        }
      </div>

      <!-- Toast Body -->
      <div class="toast-body">
        <p class="mb-0">{{ toast.message }}</p>

        <!-- Action Button -->
        @if (toast.action) {
          <div class="mt-2 pt-2 border-top border-light border-opacity-25">
            <button
              type="button"
              class="btn btn-sm btn-light"
              (click)="onActionClick(toast)"
            >
              {{ toast.action.label }}
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
